import script from "./GoodsSelectorHasPrice.vue?vue&type=script&setup=true&lang=js"
export * from "./GoodsSelectorHasPrice.vue?vue&type=script&setup=true&lang=js"

import "./GoodsSelectorHasPrice.vue?vue&type=style&index=0&id=01f50138&lang=scss&scoped=true"

import exportComponent from "D:\\work\\project\\万禾项目\\东智\\dongzhistore\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01f50138"]])

export default __exports__